(function (window) {

  window.swisAvg = {
    init: init,
    isConfigured: isConfigured,
    getAllowStats: allowStats,
    getAllowTracking: allowTracking,
    showCookieSettings: showCookieSettings
  };

  var placeholderCustomerName = '{{CUSTOMER_NAME}}';
  var settings = {
    stats: true,
    tracking: true,
    block_embeds: true,
    domain: false,
    open_when_not_configured: 'cookiebar', /* possible options: 'cookiebar', 'cookiesettings' */
    popup_closable_without_saving: false,
    popup_open_button_in_page_corner: false,
    add_accept_button_above_options: false,
    cookie_page_link: '',
    functional_label: 'Functional',
    analytical_label: 'Analytical',
    tracking_label: 'Tracking',
    bar_style: 'default',
    bar_text: '{{CUSTOMER_NAME}} uses <b>functional</b>-, <b>analytical</b> and <b>tracking-cookies</b> to improve our website. ' +
      'Therefore we save information like your IP-address, your surfing behaviour and all the personal data you share with us. ' +
      'We use your data to analyse it and use it to improve our site with third party tools. ' +
      'You can give your consent for all cookies immediately. You can also modify the cookie-settings if you don\'t want us to share this information. ' +
      'For more information about the cookies we use and the third parties we work with, you can check our cookie policy. ',
    bar_title: 'Do you also want a well-functioning site?',
    bar_accept: 'Accept cookies',
    bar_settings: 'Cookie settings',
    button_open_settings: 'Cookie settings',
    popup_title: 'Change your cookie settings',
    popup_text: '{{CUSTOMER_NAME}} uses <b>functional</b>-, <b>analytical</b> and <b>tracking-cookies</b> to improve our website. ' +
      'Therefore we save information like your IP-address, your surfing behaviour and all the personal data you share with us. ' +
      'We use your data to analyse it and use it to improve our site with third party tools. ' +
      'You can give your consent for all cookies immediately. You can also modify the cookie-settings if you don\'t want us to share this information. ' +
      'For more information about the cookies we use and the third parties we work with, you can check our cookie policy. ',
    popup_accept_top: 'Accept all',
    popup_accept: 'Accept all',
    popup_save: 'Save settings',
    popup_policy: 'Check our cookie policy',
    popup_allowed_label: 'This website will',
    popup_not_allowed_label: 'This website won\'t',
    embedded_title: 'Allow cookies to watch this item',
    embedded_text: 'Your current cookie settings prevent you from seeing this item. If you do want to see this, change your cookie settings.',
    embedded_button: 'Change cookie settings',
    cookie_rules: [
      {text: 'Place necessary cookies', type: 'functional'},
      {text: 'Keep anonymised statistics', type: 'functional'},
      {text: 'Share identifiable information', type: 'never'},
      {text: 'Keep non-anonymised statistics', type: 'stats'},
      {text: 'Share Social media', type: 'tracking'},
      {text: 'Use information for remarketing purposes', type: 'tracking'},
      {text: 'Show embedded video\'s', type: 'tracking'}
    ]
  };

  var translatedSettings = {
    nl: {
      functional_label: 'Functioneel',
      analytical_label: 'Analytisch',
      tracking_label: 'Tracking',
      bar_text: '{{CUSTOMER_NAME}} maakt gebruik van <b>functionele</b>-, <b>analytische</b>- en <b>tracking-cookies</b> om de website te verbeteren. ' +
        'Hiervoor slaan wij informatie op zoals je IP-adres, je surfgedrag en alle persoonsgegevens die je zelf bij ons achterlaat. ' +
        'Wij gebruiken deze gegevens om met tools van andere partijen deze informatie te analyseren om onze website te verbeteren. ' +
        'Je kunt nu direct toestemming geven voor al deze cookies. Ook kun je de cookie-instellingen wijzigen als je niet wilt dat wij deze informatie delen. ' +
        'Meer informatie over de cookies die wij bijhouden en de partijen waarmee wij samenwerken vind je in ons cookiebeleid. ',
      bar_title: 'Wil jij ook een goede site?',
      bar_accept: 'Accepteer cookies',
      bar_settings: 'Cookie-instellingen',
      button_open_settings: 'Cookie-instellingen',
      popup_title: 'Wijzig cookie-instellingen',
      popup_text: '{{CUSTOMER_NAME}} maakt gebruik van <b>functionele</b>-, <b>analytische</b>- en <b>tracking-cookies</b> om de website te verbeteren. ' +
        'Hiervoor slaan wij informatie op zoals je IP-adres, je surfgedrag en alle persoonsgegevens die je zelf bij ons achterlaat. ' +
        'Wij gebruiken deze gegevens om met tools van andere partijen deze informatie te analyseren om onze website te verbeteren. ' +
        'Je kunt nu direct toestemming geven voor al deze cookies. Ook kun je de cookie-instellingen wijzigen als je niet wilt dat wij deze informatie delen. ' +
        'Meer informatie over de cookies die wij bijhouden en de partijen waarmee wij samenwerken vind je in ons cookiebeleid. ',
      popup_accept_top: 'Alles toestaan',
      popup_accept: 'Alles toestaan',
      popup_save: 'Instellingen opslaan',
      popup_policy: 'Bekijk ons beleid',
      popup_allowed_label: 'De website zal',
      popup_not_allowed_label: 'De website zal niet',
      embedded_title: 'Sta cookies toe om dit item te bekijken',
      embedded_text: 'Je huidige cookie-instellingen voorkomen dat jij dit item kunt bekijken. Als je dit item toch wilt zien, wijzig dan je cookie-instellingen.',
      embedded_button: 'Wijzig cookie-instellingen',
      cookie_rules: [
        {text: 'Noodzakelijke cookies plaatsen', type: 'functional'},
        {text: 'Geanonimiseerde statistieken bijhouden', type: 'functional'},
        {text: 'Identificeerbare informatie delen', type: 'never'},
        {text: 'Niet-geanonimiseerde statistieken bijhouden', type: 'stats'},
        {text: 'Sociale media laden', type: 'tracking'},
        {text: 'Informatie gebruiken voor remarketing doeleinden', type: 'tracking'},
        {text: 'Ingesloten video\'s plaatsen', type: 'tracking'}
      ]
    },
    fr: {
      functional_label: 'Functional',
      analytical_label: 'Analytical',
      tracking_label: 'Tracking',
      bar_text: '{{CUSTOMER_NAME}} utilise des <b>cookies fonctionnels</b>, <b>analytiques</b> et <b>de pistage</b>. Ces cookies sont là pour améliorer ce site. ' +
        'Pour cela nous sauvegardons et stockons votre adresse IP, votre comportement de navigation et toutes les données personnelles que vous nous laissez sur le site. ' +
        'Nous envoyons toutes ces données à des tiers pour analyser cette information dans le but d’améliorer le site Web. ' +
        'Vous pouvez donner directement l\'autorisation pour tous les cookies. Si vous ne souhaitez pas que les cookies mesurent votre navigation et analyser votre visite sur le site, vous pouvez également modifier les paramètres des cookies. ' +
        'Vous trouverez plus d\'information sur les cookies et les parties avec lesquelles nous travaillons dans notre politique d’utilisation des cookies. ',
      bar_title: 'Tu voudrais un bon site?',
      bar_accept: 'Accepter les cookies',
      bar_settings: 'Paramètres des cookies',
      button_open_settings: 'Paramètres des cookies',
      popup_title: 'Changement les paramètres des cookies',
      popup_text: '{{CUSTOMER_NAME}} utilise des <b>cookies fonctionnels</b>, <b>analytiques</b> et <b>de pistage</b>. Ces cookies sont là pour améliorer ce site. ' +
        'Pour cela nous sauvegardons et stockons votre adresse IP, votre comportement de navigation et toutes les données personnelles que vous nous laissez sur le site. ' +
        'Nous envoyons toutes ces données à des tiers pour analyser cette information dans le but d’améliorer le site Web. ' +
        'Vous pouvez donner directement l\'autorisation pour tous les cookies. Si vous ne souhaitez pas que les cookies mesurent votre navigation et analyser votre visite sur le site, vous pouvez également modifier les paramètres des cookies. ' +
        'Vous trouverez plus d\'information sur les cookies et les parties avec lesquelles nous travaillons dans notre politique d’utilisation des cookies. ',
      popup_accept_top: 'Permettre tout',
      popup_accept: 'Permettre tout',
      popup_save: 'Souvenier paramètres',
      popup_policy: 'Page des cookies',
      popup_allowed_label: 'Ce site sera',
      popup_not_allowed_label: 'Ce site ne sera pas',
      embedded_title: 'Autoriser les cookies pour afficher cet élément',
      embedded_text: 'Vos paramètres de cookies actuels vous empêchent de voir cet élément. Si vous voulez quand même voir cet élément, changez les paramètres de vos cookies.',
      embedded_button: 'Changez les paramètres',
      cookie_rules: [
        {text: 'Placer les cookies nécessaires', type: 'functional'},
        {text: 'Conserver des informations anonymes', type: 'functional'},
        {text: 'Envoyer des informations identifiables', type: 'never'},
        {text: 'Conserver des informations non-anonymisée', type: 'stats'},
        {text: 'Utiliser les médias sociaux', type: 'tracking'},
        {text: 'Utiliser des informations à des fins de remarketing', type: 'tracking'},
        {text: 'Placer des vidéos intégrées', type: 'tracking'}
      ]
    },
    es: {
      functional_label: 'Funcional',
      analytical_label: 'Analítico',
      tracking_label: 'Rastreo',
      bar_text: '{{CUSTOMER_NAME}} utiliza cookies <b>funcionales</b>, <b>analíticas</b> y <b>de seguimiento</b> para mejorar nuestro sitio web. ' +
        'Por lo tanto, guardamos información como su dirección IP, su comportamiento de navegación y todos los datos personales que comparte con nosotros. ' +
        'Usamos su información para analizarla y utilizarla para mejorar nuestro sitio con herramientas de terceros. ' +
        'Puede dar su consentimiento para todas las cookies de inmediato. También puede modificar la configuración de cookies si no desea compartir esta información. ' +
        'Para obtener más información sobre las cookies, podemos consultar nuestra política de cookies. ',
      bar_title: 'También quieres un sitio que funcione bien?',
      bar_accept: 'Acepto cookies',
      bar_settings: 'Configuración de cookies',
      button_open_settings: 'Configuración de cookies',
      popup_title: 'Cambiar la configuración de cookies',
      popup_text: '{{CUSTOMER_NAME}} utiliza cookies <b>funcionales</b>, <b>analíticas</b> y <b>de seguimiento</b> para mejorar nuestro sitio web. ' +
        'Por lo tanto, guardamos información como su dirección IP, su comportamiento de navegación y todos los datos personales que comparte con nosotros. ' +
        'Usamos su información para analizarla y utilizarla para mejorar nuestro sitio con herramientas de terceros. ' +
        'Puede dar su consentimiento para todas las cookies de inmediato. También puede modificar la configuración de cookies si no desea compartir esta información. ' +
        'Para obtener más información sobre las cookies, podemos consultar nuestra política de cookies. ',
      popup_accept_top: 'Aceptar todo',
      popup_accept: 'Aceptar todo',
      popup_save: 'Guardar ajustes',
      popup_policy: 'Política de cookies',
      popup_allowed_label: 'Este sitio',
      popup_not_allowed_label: 'Este sitio no',
      embedded_title: 'Aceptar cookies para ver este elemento',
      embedded_text: 'Su configuración de cookies actual le impide ver este elemento. Si quieres ver esto, cambia la configuración de tus cookies.',
      embedded_button: 'cambiar la configuración',
      cookie_rules: [
        {text: 'Coloque las cookies necesarias', type: 'functional'},
        {text: 'Mantener información anónima', type: 'functional'},
        {text: 'Enviar información identificable', type: 'never'},
        {text: 'Mantenga información no anonimizada', type: 'stats'},
        {text: 'Usa las redes sociales', type: 'tracking'},
        {text: 'Utilizar información con fines de remarketing', type: 'tracking'},
        {text: 'Colocar videos incrustados', type: 'tracking'}
      ]
    },
    de: {
      functional_label: 'Funktional',
      analytical_label: 'Analytisch',
      tracking_label: 'Tracking',
      bar_text: '{{CUSTOMER_NAME}} verwendet <b>funktionale</b>, <b>analytische</b> und <b>Tracking-Cookies</b> um die Website zu verbessern. ' +
        'Dazu speichern wir Informationen wie Ihre IP-Adresse, Ihr Surfverhalten und alle persönlichen Daten, die Sie bei uns hinterlassen. ' +
        'Wir verwenden diese Daten, um diese Informationen mit Tools anderer Parteien zu analysieren, um unsere Website zu verbessern. ' +
        'Sie können jetzt sofort alle diese Cookies zulassen. Sie können die Cookie-Einstellungen auch ändern, wenn Sie nicht möchten, dass wir diese Informationen teilen. ' +
        'Weitere Informationen zu den von uns geführten Cookies und zu den Parteien, mit denen wir zusammenarbeiten, finden Sie in unserer Cookie-Richtlinie. ',
      bar_title: 'Willst du eine gute Seite?',
      bar_accept: 'Cookies akzeptieren',
      bar_settings: 'Cookie-Einstellungen',
      button_open_settings: 'Cookie-Einstellungen',
      popup_title: 'Ändern Sie die Cookie-Einstellungen',
      popup_text: '{{CUSTOMER_NAME}} verwendet <b>funktionale</b>, <b>analytische</b> und <b>Tracking-Cookies</b> um die Website zu verbessern. ' +
        'Dazu speichern wir Informationen wie Ihre IP-Adresse, Ihr Surfverhalten und alle persönlichen Daten, die Sie bei uns hinterlassen. ' +
        'Wir verwenden diese Daten, um diese Informationen mit Tools anderer Parteien zu analysieren, um unsere Website zu verbessern. ' +
        'Sie können jetzt sofort alle diese Cookies zulassen. Sie können die Cookie-Einstellungen auch ändern, wenn Sie nicht möchten, dass wir diese Informationen teilen. ' +
        'Weitere Informationen zu den von uns geführten Cookies und zu den Parteien, mit denen wir zusammenarbeiten, finden Sie in unserer Cookie-Richtlinie. ',
      popup_accept_top: 'Akzeptiere alle',
      popup_accept: 'Akzeptiere alle',
      popup_save: 'Änderungen speichern',
      popup_policy: 'Cookie-Richtlinie',
      popup_allowed_label: 'Diese Website wird',
      popup_not_allowed_label: 'Diese Website wird nicht',
      embedded_title: 'Akzeptieren Sie Cookies, um dieses Element anzuzeigen',
      embedded_text: 'Ihre aktuellen Cookie-Einstellungen verhindern, dass Sie dieses Element anzeigen können. Wenn Sie diesen Artikel trotzdem sehen möchten, ändern Sie Ihre Cookie-Einstellungen.',
      embedded_button: 'Ändern Sie die Einstellungen',
      cookie_rules: [
        {text: 'Platziere notwendige Cookies', type: 'functional'},
        {text: 'Anonyme Statistiken', type: 'functional'},
        {text: 'Teilen von identifizierbare Informationen', type: 'never'},
        {text: 'Nicht-anonymisierte Statistiken', type: 'stats'},
        {text: 'Social Media wird geladen', type: 'tracking'},
        {text: 'Informationen für Remarketing-Zwecke verwenden', type: 'tracking'},
        {text: 'Eingebettete Videos platzieren', type: 'tracking'}
      ]
    }
  };

  function init(name, options, translatedOptions) {

    var langcode = detectLangcode();

    if (translatedSettings[langcode]) {
      mergeSettings(translatedSettings[langcode]);
    }
    mergeSettings(options);
    if (translatedOptions && translatedOptions[langcode]) {
      mergeSettings(translatedOptions[langcode]);
    }

    setTimeout(checkEmbeddedElements, 0);

    settings.bar_text = settings.bar_text.replace(placeholderCustomerName, name);
    settings.popup_text = settings.popup_text.replace(placeholderCustomerName, name);

    setConsent('default');

    if (!isConfigured()) {
      if (settings.open_when_not_configured === 'cookiesettings') {
        showCookieSettings();
      }
      else {
        showCookieBar();
      }
    }

    if (settings.popup_open_button_in_page_corner) {
      createOpenSettingsButton();
    }

    window.addEventListener('click', onClickSettingsChange);
  }

  function checkEmbeddedElements() {
    if (!settings.block_embeds) {
      return;
    }
    checkEmbeddedElementsForCookieType('stats', allowStats());
    checkEmbeddedElementsForCookieType('tracking', allowTracking());
    checkEmbeddedElementsForCookieType('stats-and-tracking', allowStats() && allowTracking());
  }

  function checkEmbeddedElementsForCookieType(type, allowed) {
    var elements = document.getElementsByClassName('cookie-settings-' + type);

    if (!elements.length) {
      return;
    }

    if (allowed) {
      processEmbeddedElements(elements, unblockEmbeddedElement);
      var noEmbedElements = document.querySelectorAll('.cookie-settings-' + type + ' + .cookie-settings-no-embed');
      processEmbeddedElements(noEmbedElements, removeElement);
    }
    else {
      processEmbeddedElements(elements, blockEmbeddedElement);
    }
  }

  function processEmbeddedElements(elements, callback) {
    for (var i = 0; i < elements.length; i++) {
      callback(elements[i]);
    }
  }

  function removeElement(element) {
    element.remove();
  }

  function unblockEmbeddedElement(element) {
    var dataSrcAttr = element.getAttribute('data-src');
    if (dataSrcAttr) {
      element.setAttribute('src', dataSrcAttr);
      element.removeAttribute('style');
    }

    var cookieEmbedMessage = getEmbeddedMessage(element);

    if (cookieEmbedMessage) {
      cookieEmbedMessage.parentNode.removeChild(cookieEmbedMessage);
    }
  }

  function blockEmbeddedElement(element) {
    element.setAttribute('style', 'display: none;');
    var cookieEmbedMessage = getEmbeddedMessage(element);
    if (!cookieEmbedMessage) {
      var parent = element.parentElement;
      var newEl = document.createElement('DIV');
      newEl.className = 'cookie-settings-no-embed';
      newEl.innerHTML = '<div class="cookie-settings-no-embed__title">' + settings.embedded_title + '</div><div class="cookie-settings-no-embed__text">' + settings.embedded_text + '</div><button class="cookie-settings-change cookie-settings-no-embed__btn">' + settings.embedded_button + '</button>';
      if (element.nextElementSibling) {
        parent.insertBefore(newEl, element.nextElementSibling);
      }
      else {
        parent.appendChild(newEl);
      }
    }
  }

  function getEmbeddedMessage(element) {
    var cookieEmbedMessage = element.nextElementSibling;

    while (cookieEmbedMessage && !cookieEmbedMessage.classList.contains('cookie-settings-no-embed') && cookieEmbedMessage.nextElementSibling) {
      cookieEmbedMessage = cookieEmbedMessage.nextElementSibling;
    }
    if (!cookieEmbedMessage || !cookieEmbedMessage.classList.contains('cookie-settings-no-embed')) {
      return;
    }

    return cookieEmbedMessage;
  }

  function mergeSettings(options) {
    for (var attrname in options) {
      if (attrname in options) {
        settings[attrname] = options[attrname];
      }
    }
  }

  function detectLangcode() {
    return document.documentElement.getAttribute('lang') || 'nl';
  }

  function onClickSettingsChange(event) {
    let target = event.target;

    while (target && target instanceof Element && target.parentNode && (!target.classList.contains('cookie-settings-change') && target.getAttribute('href') !== '#cookie-settings-change')) {
      target = target.parentNode;
    }

    if (target && target instanceof Element && (target.classList.contains('cookie-settings-change') || target.getAttribute('href') === '#cookie-settings-change')) {
      showCookieSettings();
    }
  }

  function getCookieBar() {
    var cookieBar = document.getElementById('cookie-bar');
    if (!cookieBar) {
      cookieBar = createCookieBar();
    }
    return cookieBar;
  }

  function createCookieBar() {
    switch (settings.bar_style) {
      case 'inline-settings':
        return getInlineSettingsCookieBar();
      default:
        return getDefaultCookieBar();
    }
  }

  function getDefaultCookieBar() {
    var cookieBarBody =
      '  <div class="cookie-bar__content">' +
      '    <div class="cookie-bar__title">' + settings.bar_title + '</div>' +
      '    <div class="cookie-bar__text">' +
      '        <div class="cookie-bar__text-body">' + settings.bar_text;
    if (settings.cookie_page_link !== '') {
      cookieBarBody += ' <a class="cookie-settings__info-link-to-policy" href=' + settings.cookie_page_link + '>' + settings.popup_policy + '</a>';
    }
    cookieBarBody += '</div>' +
      '    </div>' +
      '    <div class="cookie-bar__settings">' +
      '        <div class="cookie-bar__settings-button" id="cookie-bar__settings-accept">' + settings.bar_accept + '</div>' +
      '        <div class="cookie-bar__settings-button" id="cookie-bar__settings-open">' + settings.bar_settings + '</div>' +
      '    </div>' +
      '  </div>';

    var cookieBar = document.createElement('DIV');
    cookieBar.className = 'cookie-bar';
    cookieBar.id = 'cookie-bar';
    cookieBar.innerHTML = cookieBarBody;
    document.body.appendChild(cookieBar);

    document.getElementById('cookie-bar__settings-open').addEventListener('click', showCookieSettings);
    document.getElementById('cookie-bar__settings-accept').addEventListener('click', onAcceptAllCookies);

    return cookieBar;
  }

  function getInlineSettingsCookieBar() {
    var cookieSettings = createCookieSettings();
    var bem = ['cookie-bar__content'];
    if (!cookieSettings) {
      bem.push('cookie-bar__content--without-settings');
    }

    var cookieBarBody =
      '  <div class="' + bem.join(' ') + '">' +
      '   <div class="cookie-bar__body">' +
      '     <div class="cookie-bar__title">' + settings.bar_title + '</div>' +
      '     <div class="cookie-bar__text">' +
      '         <div class="cookie-bar__text-body">' + settings.bar_text +
      '         </div>' +
      '       </div>' +
      '     <div class="cookie-bar__settings">';
    if (settings.cookie_page_link !== '') {
      cookieBarBody += ' <a class="cookie-settings__info-link-to-policy" href=' + settings.cookie_page_link + '>' + settings.popup_policy + '</a>';
    }
    cookieBarBody +=
      '       <div class="cookie-bar__settings-button" id="cookie-bar__settings-accept">' + settings.bar_accept + '</div>' +
      '     </div>' +
      '   </div>';
    if (cookieSettings) {
      cookieBarBody += cookieSettings.innerHTML;
    }
    cookieBarBody +=
      '  </div>';

    var cookieBar = document.createElement('DIV');
    cookieBar.className = 'cookie-bar cookie-bar-inline-settings';
    cookieBar.id = 'cookie-bar';
    cookieBar.innerHTML = cookieBarBody;

    document.body.appendChild(cookieBar);

    if (cookieSettings) {
      checkAllowedCookies();
    }

    var acceptButton = document.getElementById('cookie-bar__settings-accept');
    if (acceptButton) {
      acceptButton.addEventListener('click', onAcceptAllCookies);
    }
    var saveButton = document.getElementById('cookie-settings__save-settings');
    if (saveButton) {
      saveButton.addEventListener('click', onSaveSettings);
    }

    return cookieBar;
  }

  function showCookieBar() {
    var cookieBar = getCookieBar();
    if (cookieBar) {
      cookieBar.classList.remove('cookie-bar--hidden');

      if (settings.bar_style === 'inline-settings') {
        checkAllowedCookies();
      }
    }
  }

  function hideCookieBar() {
    var cookieBar = getCookieBar();
    if (cookieBar) {
      cookieBar.classList.add('cookie-bar--hidden');
    }
  }

  function createCookieSettings() {
    var cookieSettings = document.getElementById('cookie-settings');
    if (cookieSettings) {
      return cookieSettings;
    }

    switch (settings.bar_style) {
      case 'inline-settings':
        return getInlineCookieSettings();
      default:
        return getDefaultCookieSettings();
    }
  }

  function getDefaultCookieSettings() {
    var popupBody =
      '    <div class="cookie-settings__container">' +
      '        <div class="cookie-settings__title-bar">' +
      '            <div class="cookie-settings__title">' + settings.popup_title + '</div>';
    if (settings.popup_closable_without_saving) {
      popupBody +=
        '            <div class="cookie-settings__close" id="cookie-settings__close">&times;</div>';
    }
    popupBody +=
      '        </div>' +
      '        <div class="cookie-settings__content">' +
      '             <div class="cookie-settings__info">' +
      settings.popup_text;
    if (settings.cookie_page_link !== '') {
      popupBody += '   <a class="cookie-settings__info-link-to-policy" href=' + settings.cookie_page_link + '>' + settings.popup_policy + '</a>';
    }
    popupBody += '  </div>';
    if (settings.add_accept_button_above_options) {
      popupBody += '<div class="cookie-settings__save-top-button" id="cookie-settings__accept-all-top-button">' + settings.popup_accept_top + '</div>';
    }
    popupBody += getCookieSettingsOptions();
    popupBody += getCookieSettingsRulesList();
    popupBody += '<div class="cookie-settings__actions">' +
      '                <div class="cookie-settings__save" id="cookie-settings__save-settings">' + settings.popup_save + '</div>' +
      '                <div class="cookie-settings__save" id="cookie-settings__accept-all">' + settings.popup_accept + '</div>' +
      '            </div>' +
      '         </div>' +
      '     </div>';

    var cookieSettings = document.createElement('DIV');
    cookieSettings.className = 'cookie-settings cookie-settings--hidden';
    cookieSettings.id = 'cookie-settings';
    cookieSettings.innerHTML = popupBody;

    document.body.appendChild(cookieSettings);

    var checkBoxes = document.getElementsByClassName('cookie-settings__options-item-checkbox');

    for (var i = 0; i < checkBoxes.length; i++) {
      checkBoxes[i].addEventListener('change', updateLists);
    }

    document.getElementById('cookie-settings__accept-all').addEventListener('click', onAcceptAllCookies);

    var acceptAllTopButton = document.getElementById('cookie-settings__accept-all-top-button');
    if (acceptAllTopButton !== null) {
      acceptAllTopButton.addEventListener('click', onAcceptAllCookies);
    }

    document.getElementById('cookie-settings__save-settings').addEventListener('click', onSaveSettings);

    var close = document.getElementById('cookie-settings__close');
    if (close !== null) {
      close.addEventListener('click', onCloseCookieSettings);
    }

    return cookieSettings;
  }

  function getInlineCookieSettings() {
    if (!settings.stats && !settings.tracking) {
      return false;
    }

    var settingsBody =
      '    <div class="cookie-settings__container">' +
      '        <div class="cookie-settings__content">';
    settingsBody += getCookieSettingsOptions();
    settingsBody += '<div class="cookie-settings__actions">' +
      '                  <div class="cookie-settings__save" id="cookie-settings__save-settings">' + settings.popup_save + '</div>' +
      '              </div>';
    settingsBody += '</div>' +
      '     </div>';

    var cookieSettings = document.createElement('DIV');
    cookieSettings.className = 'cookie-settings';
    cookieSettings.id = 'cookie-settings';
    cookieSettings.innerHTML = settingsBody;

    return cookieSettings;
  }

  function getCookieSettingsOptions() {
    var options =
      '        <div class="cookie-settings__options">' +
      '            <label class="cookie-settings__options-item cookie-settings__options-item--functional cookie-settings__options-item--checked">' +
      '                <div class="cookie-settings__options-item-text">' + settings.functional_label + '</div>' +
      '                <input type="checkbox" class="cookie-settings__options-item-checkbox" name="swis-avg-allow-functional" disabled checked>' +
      '            </label>';
    if (settings.stats) {
      options +=
        '            <label class="cookie-settings__options-item cookie-settings__options-item--stats">' +
        '                <div class="cookie-settings__options-item-text">' + settings.analytical_label + '</div>' +
        '                <input type="checkbox" class="cookie-settings__options-item-checkbox" name="swis-avg-allow-stats">' +
        '            </label>';
    }
    if (settings.tracking) {
      options +=
        '            <label class="cookie-settings__options-item cookie-settings__options-item--tracking">' +
        '                <div class="cookie-settings__options-item-text">' + settings.tracking_label + '</div>' +
        '                <input type="checkbox" class="cookie-settings__options-item-checkbox" name="swis-avg-allow-tracking">' +
        '            </label>';
    }
    options += '</div>';

    return options;
  }

  function getCookieSettingsRulesList() {
    var list = '';
    var allowedRules = '';
    var notAllowedRules = '';

    for (var key in settings.cookie_rules) {
      if (!(key in settings.cookie_rules)) {
        continue;
      }
      var rule = settings.cookie_rules[key];
      var cookieRuleHMTL = '<div class="cookie-settings__list-li"  data-cookie-setting="swis-avg-allow-' + rule.type + '">' + rule.text + '</div>';
      if (allowCookie(rule.type)) {
        allowedRules += cookieRuleHMTL;
      }
      else {
        notAllowedRules += cookieRuleHMTL;
      }
    }
    list +=
      '            <div class="cookie-settings__list">' +
      '                <div class="cookie-settings__list-items cookie-settings__list--allowed">' +
      '                    <div class="cookie-settings__list-title">' + settings.popup_allowed_label + ':</div>' +
      '                    <div class="cookie-settings__list-ul" id="cookie-settings__list-ul--allowed">' +
      allowedRules +
      '                    </div>' +
      '                </div>' +
      '                <div class="cookie-settings__list-items cookie-settings__list--not-allowed">' +
      '                    <div class="cookie-settings__list-title">' + settings.popup_not_allowed_label + ':</div>' +
      '                    <div class="cookie-settings__list-ul" id="cookie-settings__list-ul--not-allowed">' +
      notAllowedRules +
      '                    </div>' +
      '                </div>' +
      '            </div>';

    return list;
  }

  function showCookieSettings() {
    var cookieSettings = null;

    switch (settings.bar_style) {
      case 'inline-settings':
        showCookieBar();
        return;
      default:
        cookieSettings = createCookieSettings();
    }

    if (cookieSettings) {
      checkAllowedCookies();
      // setTimeout to give the browser time to render the DOM elements for animations
      setTimeout(function () {
        cookieSettings.classList.remove('cookie-settings--hidden');
      }, 10);

      document.documentElement.classList.add('cookie-settings-viewport');
    }
  }

  function hideCookieSettings() {
    var cookieSettings = createCookieSettings();
    if (cookieSettings) {
      cookieSettings.classList.add('cookie-settings--hidden');
      document.documentElement.classList.remove('cookie-settings-viewport');
    }
  }

  function checkAllowedCookies() {
    if (!settings.stats && !settings.tracking) {
      return;
    }

    var statsLabel = document.querySelector('.cookie-settings__options-item--stats');
    var statsCheckbox = document.querySelector('[name="swis-avg-allow-stats"]');
    if (getCookie('SWIS_AVG_ALLOW_STATS') === 'true') {
      if (statsLabel) {
        statsLabel.classList.add('cookie-settings__options-item--checked');
      }
      if (statsCheckbox) {
        statsCheckbox.checked = true;
      }
    }
    else {
      if (statsLabel) {
        statsLabel.classList.remove('cookie-settings__options-item--checked');
      }
      if (statsCheckbox) {
        statsCheckbox.checked = false;
      }
    }

    var trackingLabel = document.querySelector('.cookie-settings__options-item--tracking');
    var trackingCheckbox = document.querySelector('[name="swis-avg-allow-tracking"]');
    if (getCookie('SWIS_AVG_ALLOW_TRACKING') === 'true') {
      if (trackingLabel) {
        trackingLabel.classList.add('cookie-settings__options-item--checked');
      }
      if (trackingCheckbox) {
        trackingCheckbox.checked = true;
      }
    }
    else {
      if (trackingLabel) {
        trackingLabel.classList.remove('cookie-settings__options-item--checked');
      }
      if (trackingCheckbox) {
        trackingCheckbox.checked = false;
      }
    }
  }

  function createOpenSettingsButton() {
    var cookieOpenSettingsBody =
      '  <div class="cookie-settings-button__button" id ="cookie-settings-button__button">' + settings.button_open_settings + '</div>';

    var cookieOpenSettings = document.createElement('DIV');
    cookieOpenSettings.className = 'cookie-settings-button';
    cookieOpenSettings.id = 'cookie-settings-button';
    cookieOpenSettings.innerHTML = cookieOpenSettingsBody;

    document.body.appendChild(cookieOpenSettings);

    document.getElementById('cookie-settings-button__button').addEventListener('click', showCookieSettings);

    return cookieOpenSettings;
  }

  function hideBarAndSettings() {
    hideCookieSettings();
    hideCookieBar();
  }

  function onAcceptAllCookies() {
    saveConsent(settings.stats, settings.tracking);
    hideBarAndSettings();
  }

  function onSaveSettings() {
    var allowStats = document.getElementsByName('swis-avg-allow-stats')[0] ? document.getElementsByName('swis-avg-allow-stats')[0].checked : true;
    var allowTracking = document.getElementsByName('swis-avg-allow-tracking')[0] ? document.getElementsByName('swis-avg-allow-tracking')[0].checked : true;
    saveConsent(allowStats, allowTracking);
    hideBarAndSettings();
  }

  function onCloseCookieSettings() {
    hideCookieSettings();
  }

  function saveConsent(allowStats, allowTracking) {
    if (typeof allowStats !== 'boolean') {
      allowStats = false;
    }
    if (typeof allowTracking !== 'boolean') {
      allowTracking = false;
    }

    setCookie('SWIS_AVG_ALLOW_STATS', allowStats, 365);
    setCookie('SWIS_AVG_ALLOW_TRACKING', allowTracking, 365);
    broadcastConsent(allowStats, allowTracking);
    logConsent(allowStats, allowTracking);
    setTimeout(checkEmbeddedElements, 0);
  }

  function setConsent(event, allowStatsParam, allowTrackingParam) {
    var gtag = function gtag() {
      window.dataLayer.push(arguments)
    };

    allowStatsParam = allowStatsParam ? allowStatsParam : allowStats();
    allowTrackingParam = allowTrackingParam ? allowTrackingParam : allowTracking();

    gtag('consent', event, {
      ad_storage: allowTrackingParam ? 'granted' : 'denied',
      ad_user_data: allowTrackingParam ? 'granted' : 'denied',
      ad_personalization: allowTrackingParam ? 'granted' : 'denied',
      analytics_storage: allowStatsParam ? 'granted' : 'denied',
      functionality_storage: 'granted',
      personalization_storage: allowTrackingParam ? 'granted' : 'denied',
      security_storage: 'granted',
    })
  }

  function broadcastConsent(allowStats, allowTracking) {
    window.dataLayer.push({
      event: 'swisAvg.consentChanged',
      allow_stats: allowStats,
      allow_tracking: allowTracking
    });

    setConsent('update', allowStats, allowTracking);
  }

  function logConsent(allowStats, allowTracking) {
    var domain = document.location.protocol + '//' + document.location.host;
    var tracking = allowTracking ? 1 : 0;
    var stats = allowStats ? 1 : 0;

    var xhr = new XMLHttpRequest();

    xhr.open('POST', 'https://avg.swis.nl/log');
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    xhr.send(encodeURI('domain=' + domain + '&allow_tracking=' + tracking + '&allow_stats=' + stats));
  }

  function isConfigured() {
    if (!settings.stats) {
      return getCookie('SWIS_AVG_ALLOW_TRACKING');
    }

    if (!settings.tracking) {
      return getCookie('SWIS_AVG_ALLOW_STATS');
    }

    return getCookie('SWIS_AVG_ALLOW_STATS') && getCookie('SWIS_AVG_ALLOW_TRACKING');
  }

  function allowCookie(type) {
    switch (type) {
      case 'functional':
        return allowFunctional();
      case 'tracking':
        return allowTracking();
      case 'stats':
        return allowStats();
      case 'unused':
        return false;
      default:
        return false;
    }
  }

  function allowFunctional() {
    return true;
  }

  function allowStats() {
    return getCookie('SWIS_AVG_ALLOW_STATS') === 'true';
  }

  function allowTracking() {
    return getCookie('SWIS_AVG_ALLOW_TRACKING') === 'true';
  }

  function updateLists() {
    var elements = document.querySelectorAll('[data-cookie-setting=' + this.name + ']');
    var ALLOWED_ID = 'cookie-settings__list-ul--allowed';
    var NOT_ALLOWED_ID = 'cookie-settings__list-ul--not-allowed';
    if (!this.checked) {
      this.parentElement.classList.remove('cookie-settings__options-item--checked');
    }
    else {
      this.parentElement.classList.add('cookie-settings__options-item--checked');
    }

    for (var i = 0, listId; i < elements.length; i++) {
      listId = elements[i].parentElement.id;
      if (listId === NOT_ALLOWED_ID && this.checked) {
        document.getElementById(ALLOWED_ID).appendChild(elements[i]);
      }
      else if (listId === ALLOWED_ID && !this.checked) {
        document.getElementById(NOT_ALLOWED_ID).appendChild(elements[i]);
      }
    }
  }

  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = 'expires=' + d.toUTCString();

    var host = window.location.host;
    if (settings.domain) {
      host = settings.domain;
    }

    var domain = 'domain=' + host;
    document.cookie = `${cname}=${cvalue};${expires};${domain};path=/`;
  }

  function getCookie(cname) {
    var name = cname + '=';
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return false;
  }

})(window);
